import type {
    Component,
    ComponentOptionsWithArrayProps,
    ComponentOptionsWithObjectProps,
    ComponentPropsOptions
} from '@vue/runtime-core';
import type { ComponentOptionsMixin } from 'vue';

export type NonFunctionPropertyNames<T> = {
    [K in keyof T]: T[K] extends Function  ? never : K
}[keyof T];

export type ComponentProps<T> = Omit<Pick<T, NonFunctionPropertyNames<T>>, `$${string}`>

export function getComponentProps(component: Component|ComponentOptionsWithArrayProps|ComponentOptionsWithObjectProps): ComponentPropsOptions {

    let propsComp = component as ComponentOptionsWithArrayProps|ComponentOptionsWithObjectProps;
    const results = {};

    if(propsComp.props){
        Object.assign(results, propsComp.props);
    }

    if(propsComp.mixins){

        for(let mixin of propsComp.mixins){

            if(mixin.props){
                Object.assign(results, mixin.props);
            }
        }
    }

    return results;
}

export function createComponentMixin(component: any, ...mixins: ComponentOptionsMixin[]): ComponentOptionsMixin {

    const mixinProps = (mixins || []).map(mixin => mixin.props);

    return {
        props: Object.assign({}, component.props, ...mixinProps)
    }
}